import Items from '@/_legacy/views/ChecklistBuilder/Build/Items/Items';

export default {
  functional: true,
  render(createElement, { props }) {
    return createElement(Items, {
      props: {
        items: props.item.items,
        resource: props.resource,
        parent: props.item,
        level: 0,
      },
    });
  },
};
